import { StyleSheet } from 'react-native';
import { AdminColors } from '../../constants/adminColors';
import FontFamily from '../../../../constants/fonts';

export const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: AdminColors.bgPage,
  },
  content: {
    padding: 32,
    paddingBottom: 60,
  },
  pageHeader: {
    marginBottom: 20,
  },
  pageTitle: {
    fontSize: 28,
    fontWeight: '700',
    color: AdminColors.textPrimary,
    fontFamily: FontFamily.bold,
    lineHeight: 40,
  },
  pageSubtitle: {
    fontSize: 14,
    color: AdminColors.textSecondary,
    fontFamily: FontFamily.regular,
    marginTop: 4,
  },
  tabBar: {
    marginBottom: 0,
    borderBottomWidth: 2,
    borderBottomColor: AdminColors.borderTable,
  },
  tabBarContent: {
    flexDirection: 'row',
    paddingRight: 8,
  },
  tab: {
    paddingHorizontal: 16,
    paddingVertical: 8,
    borderBottomWidth: 3,
    borderBottomColor: 'transparent',
    marginBottom: -2,
  },
  tabActive: {
    borderBottomColor: AdminColors.blue700,
  },
  tabLabel: {
    fontSize: 13,
    fontWeight: '500',
    color: AdminColors.textSecondary,
    fontFamily: FontFamily.medium,
    lineHeight: 18,
  },
  tabLabelActive: {
    color: AdminColors.blue700,
    fontWeight: '700',
    fontFamily: FontFamily.bold,
  },
  surface: {
    backgroundColor: AdminColors.bgSurface,
    borderRadius: 8,
    shadowColor: '#005EC0',
    shadowOffset: { width: 0, height: 0 },
    shadowOpacity: 0.08,
    shadowRadius: 24,
    elevation: 2,
    overflow: 'hidden',
    marginTop: 12,
  },
  addButtonRow: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    marginTop: 16,
    marginBottom: 4,
  },
  formRow: {
    flexDirection: 'row',
    gap: 12,
  },
  formHalf: {
    flex: 1,
  },
  textArea: {
    borderWidth: 1,
    borderColor: AdminColors.borderDefault,
    borderRadius: 5,
    paddingHorizontal: 10,
    paddingVertical: 6,
    fontSize: 13,
    color: AdminColors.textPrimary,
    backgroundColor: AdminColors.bgSurface,
    fontFamily: FontFamily.regular,
    minHeight: 80,
    textAlignVertical: 'top',
  },
  charCount: {
    fontSize: 10,
    color: AdminColors.textMuted,
    fontFamily: FontFamily.regular,
    textAlign: 'right',
    marginTop: 2,
  },
  fieldError: {
    fontSize: 11,
    color: '#DC2626',
    fontFamily: FontFamily.regular,
    marginTop: 4,
  },
  emptyState: {
    paddingVertical: 40,
    alignItems: 'center',
    justifyContent: 'center',
  },
  emptyStateText: {
    fontSize: 14,
    color: AdminColors.textSecondary,
    fontFamily: FontFamily.regular,
    textAlign: 'center',
  },
  fileUploadArea: {
    borderWidth: 2,
    borderStyle: 'dashed',
    borderColor: AdminColors.borderDefault,
    borderRadius: 6,
    padding: 16,
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: 72,
  },
  fileUploadAreaSelected: {
    borderColor: AdminColors.blue700,
    borderStyle: 'solid',
    backgroundColor: '#EFF6FF',
  },
  fileUploadAreaUploading: {
    borderColor: '#0066CC',
    borderStyle: 'solid',
    backgroundColor: 'rgba(0,102,204,0.04)',
  },
  fileUploadProgressContainer: {
    width: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: 4,
  },
  fileUploadProgressText: {
    fontSize: 11,
    color: AdminColors.textSecondary,
    fontFamily: FontFamily.regular,
    marginTop: 6,
    textAlign: 'center',
  },
  fileUploadAreaError: {
    borderColor: '#DC2626',
    backgroundColor: '#FEF2F2',
  },
  fileUploadSelectedRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
  },
  fileUploadSelectedName: {
    fontSize: 13,
    color: AdminColors.textPrimary,
    fontFamily: FontFamily.medium,
    flex: 1,
    marginRight: 8,
  },
  fileUploadClearBtn: {
    padding: 4,
  },
  fileUploadClearText: {
    fontSize: 15,
    color: AdminColors.gray400,
    fontWeight: '600',
  },
  fileUploadErrorText: {
    color: '#DC2626',
    fontSize: 11,
    fontFamily: FontFamily.regular,
    marginTop: 4,
  },
  fileUploadText: {
    fontSize: 13,
    fontWeight: '500',
    color: AdminColors.textSecondary,
    fontFamily: FontFamily.medium,
  },
  fileUploadSub: {
    fontSize: 11,
    color: AdminColors.textMuted,
    fontFamily: FontFamily.regular,
    marginTop: 4,
  },
});
